import { createPostApi } from "@api/util/createPostApi";

import type { IApiResponse } from "@api";

import type { IPathBaseParam } from "./path";
import type { ITransferUnitsDto } from "./types";

const postApis = createPostApi<
  IApiResponse<unknown>,
  IPathBaseParam,
  ITransferUnitsDto
>("stores.warehouses.transferUnits");

export const transferUnits = {
  ...postApis,
};
